/* eslint-disable jsx-a11y/alt-text */
import { memo } from 'react'

const Image = (props: { src: string; alt: string }) => {
  return <img {...props} />
}

export default memo(Image)
